import React, { useEffect, useState } from 'react';
import { trackFb } from '../utils/fbPixel';
import { useTrackSection } from '../utils/useTrackSection';
const comparisonRows = [{
  without: '100+ horas/año documentando sin sistema',
  with: '10 min/sesión. El resto es atender.'
}, {
  without: 'Protocolos improvisados → sin criterio clínico',
  with: 'Protocolos por fases listos para aplicar'
}, {
  without: '60% de pacientes abandonan antes del mes 3',
  with: 'Sistema de seguimiento → adherencia +75%'
}, {
  without: 'Sin progresión clínica estructurada',
  with: '6 tomos secuenciados → progresan y recomiendan'
}, {
  without: 'Cancelación = sesión perdida sin respaldo',
  with: 'Reglamento + consentimiento listos para usar'
}, {
  without: 'Evoluciones que tardan horas',
  with: 'Registro SOAP en 1 página en 5 min'
}, {
  without: 'Cobro irregular e incómodo',
  with: 'Abono blindado → cobro el día 1-5'
}, {
  without: 'Sin identidad profesional visible',
  with: 'Sistema que justifica cobrar 30-50% más'
}, {
  without: 'Informes para Obras Sociales desde cero',
  with: 'Plantillas listas con lenguaje técnico correcto'
}];
const TIMER_KEY = 'megapack_kinesiologia_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
export function DarkCTA() {
  useTrackSection('dark-cta', 'Final CTA Section');
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  const trackFbCheckout = (name: string, value: number) => {
    trackFb('InitiateCheckout', {
      content_name: name,
      content_category: 'Kinesiología Resuelta',
      value,
      currency: 'ARS'
    });
  };
  return <section id="dark-cta" className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(235,248,255) 0%, rgb(224,247,255) 15%, rgb(224,247,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-88">
      <div className="mx-auto max-w-4xl text-center" data-id="element-89">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-[18px]" style={{
        color: '#0077B6'
      }} data-id="element-90">
          🦴 MEGAPACK KINESIOLOGÍA RESUELTA™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-91">
          La próxima sesión podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black m-0 mb-10" style={{
        color: '#0077B6'
      }} data-id="element-92">
          O podés entrar el lunes con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl text-left" style={{
        border: '1px solid rgba(0,119,182,0.20)',
        backgroundColor: 'rgb(255,255,255)'
      }} data-id="element-93">
          {/* Table Title */}
          <div className="text-center font-bold text-gray-900 px-4 py-4" style={{
          backgroundColor: 'rgba(0,119,182,0.05)',
          borderBottom: '1px solid rgba(0,119,182,0.15)'
        }} data-id="element-94">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-2" style={{
          backgroundColor: 'rgba(0,119,182,0.03)',
          borderBottom: '1px solid rgba(0,119,182,0.15)'
        }} data-id="element-95">
            <div className="text-center font-bold text-gray-400 px-4 py-3 text-sm" data-id="element-96">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold px-4 py-3 text-sm" style={{
            color: '#0077B6',
            borderLeft: '1px solid rgba(0,119,182,0.15)'
          }} data-id="element-97">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-2" style={{
          borderBottom: i < comparisonRows.length - 1 ? '1px solid rgba(0,119,182,0.08)' : 'none'
        }} data-id="element-98">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-400" data-id="element-99">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900" style={{
            backgroundColor: 'rgba(0,119,182,0.04)',
            borderLeft: '1px solid rgba(0,119,182,0.10)'
          }} data-id="element-100">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-101">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-102">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-103">
            {[{
            val: pad(timeLeft.hours),
            label: 'hs'
          }, {
            val: ':',
            label: null
          }, {
            val: pad(timeLeft.minutes),
            label: 'min'
          }, {
            val: ':',
            label: null
          }, {
            val: pad(timeLeft.seconds),
            label: 'seg'
          }].map((item, i) => item.label === null ? <span key={i} className="mb-4 text-5xl sm:text-7xl font-black" style={{
            color: 'rgb(255,68,68)'
          }} data-id="element-104">
                  {item.val}
                </span> : <div key={i} className="flex flex-col items-center" data-id="element-105">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-106">
                    {item.val}
                  </span>
                  <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-107">
                    {item.label}
                  </span>
                </div>)}
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-108">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-109">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-110">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm" style={{
          backgroundColor: 'rgb(255,255,255)',
          border: '1px solid rgba(0,119,182,0.20)'
        }} data-id="element-111">
            <div className="mb-2 text-2xl" data-id="element-112">🦴</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-113">
              MEGAPACK KINESIOLOGÍA RESUELTA
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-114">
              6 Tomos + 6 Bonos · Sistema Clínico Completo
            </p>
            <div className="mt-auto" data-id="element-115">
              <p className="text-sm text-gray-400 line-through m-0 mb-1" data-id="element-116">
                Antes: $58.990 ARS
              </p>
              <p className="text-2xl font-black m-0 mb-4" style={{
              color: '#0077B6'
            }} data-id="element-117">
                Hoy: $22.990 ARS
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48271060336810:1" onClick={() => trackFbCheckout('Megapack Kinesiología Resuelta', 22990)} className="block text-white text-center text-sm font-black rounded-xl py-4 no-underline transition-all hover:scale-[1.02] active:scale-[0.98]" style={{
              backgroundColor: '#0077B6',
              border: '3px solid rgba(0,119,182,0.40)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.15), 0 0 0 1px rgba(255,255,255,0.10) inset'
            }} data-id="element-118">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm" style={{
          backgroundColor: 'rgba(0,119,182,0.05)',
          border: '2px solid #0077B6',
          boxShadow: 'rgba(0,119,182,0.15) 0px 0px 30px 0px'
        }} data-id="element-119">
            <div className="mb-2 text-2xl" data-id="element-120">🏆</div>
            <h3 className="text-base font-black m-0 mb-1" style={{
            color: '#0077B6'
          }} data-id="element-121">
              MÉTODO KINE PRO ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-122">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-123">
              6 Tomos + 6 Bonos + 10 editables prácticos
              <br data-id="element-124" />
              Sistema Integral de Consultorio Kinésico
            </p>
            <div className="mt-auto" data-id="element-125">
              <p className="text-sm text-gray-400 line-through m-0 mb-1" data-id="element-126">
                Antes: $102.990 ARS
              </p>
              <p className="text-3xl font-black m-0 mb-4" style={{
              color: '#0077B6'
            }} data-id="element-127">
                Hoy: $29.990 ARS
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48271060730026:1" onClick={() => trackFbCheckout('Método Kine Pro', 29990)} className="block text-white text-center text-sm font-black rounded-xl py-4 no-underline transition-all hover:scale-[1.02] active:scale-[0.98]" style={{
              backgroundColor: '#0077B6',
              border: '3px solid rgba(0,119,182,0.40)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.15), 0 0 0 1px rgba(255,255,255,0.10) inset'
            }} data-id="element-128">
                → QUIERO EL MÉTODO KINE PRO
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-129">
          <span data-id="element-130">🔒 Pago 100% seguro</span>
          <span data-id="element-131">⚡ Acceso en 5 minutos</span>
          <span data-id="element-132">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-133">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}